export enum ReleaseNoteEnum {
  Feature = 'Feature',
  LandingPage = 'Landing Page',
  LaunchPad = 'LaunchPad'
}
